document.addEventListener('DOMContentLoaded',()=>{
  document.documentElement.classList.remove('no-js');
  const targets=document.querySelectorAll('[data-reveal],.kei-drop,[data-brake],[data-smash],[data-stamp]');
  const io=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}}),{threshold:.18,rootMargin:'0px 0px -6% 0px'});
  targets.forEach(el=>io.observe(el));
  /* menu handled by FIX25 controller below */
});

/* TONARIS / SHOKUNIN interaction refinement — visual behavior only */
(() => {
  const root = document.documentElement;
  const header = document.querySelector('.tnrs-header');
  const onScroll = () => root.classList.toggle('tn-scrolled', window.scrollY > 24);
  onScroll(); window.addEventListener('scroll', onScroll, {passive:true});

  const menu = document.querySelector('[data-menu]');
  const mobile = document.querySelector('.tnrs-mobile');
  const close = document.querySelector('[data-menu-close]');
  const label = menu && menu.querySelector('[data-menu-label]');
  const setMenu = (open) => {
    if (!menu || !mobile) return;
    mobile.classList.toggle('is-open', open);
    mobile.classList.remove('open');
    menu.setAttribute('aria-expanded', String(open));
    mobile.setAttribute('aria-hidden', String(!open));
    if(label) label.textContent = open ? 'CLOSE' : 'MENU';
    document.documentElement.classList.toggle('tn-menu-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  };
  if (menu && mobile) {
    menu.addEventListener('click', () => setMenu(!mobile.classList.contains('is-open')));
    if(close) close.addEventListener('click', () => setMenu(false));
    mobile.querySelectorAll('a').forEach(a => a.addEventListener('click', () => setMenu(false)));
    document.addEventListener('keydown', e => { if(e.key === 'Escape') setMenu(false); });
  }

  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const targets = document.querySelectorAll('.tn-world,.tn-work,.tn-product,.tn-note,.tn15-index-card,.tn15-feature-media');
    targets.forEach((el, i) => { el.style.opacity='0'; el.style.transform='translateY(24px)'; el.style.transitionDelay=`${Math.min(i%4,3)*55}ms`; });
    const io = new IntersectionObserver(entries => entries.forEach(entry => {
      if(entry.isIntersecting){ entry.target.style.opacity='1'; entry.target.style.transform='translateY(0)'; io.unobserve(entry.target); }
    }), {threshold:.08, rootMargin:'0px 0px -7%'});
    targets.forEach(el => io.observe(el));
  }
})();

/* FIX32 — HERO VIDEO DIAGNOSTICS */
(() => {
  const heroes = document.querySelectorAll('[data-tn-hero][data-debug="true"]');
  heroes.forEach(hero => {
    const box = hero.querySelector('[data-tn-video-debug]');
    if (!box) return;
    const update = () => {
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const wrap = hero.querySelector(mobile ? '.tn-hero__mobile' : '.tn-hero__desktop');
      const video = wrap && wrap.querySelector('video');
      if (!video) { box.innerHTML = 'TONARIS VIDEO DEBUG<br>NO ACTIVE VIDEO'; return; }
      const r = video.getBoundingClientRect();
      const vw = video.videoWidth || 0, vh = video.videoHeight || 0;
      const scale = vw ? Math.max(r.width / vw, r.height / vh) : 0;
      const src = video.currentSrc || video.querySelector('source')?.src || '';
      const shortSrc = src ? src.split('?')[0].split('/').pop() : 'n/a';
      box.innerHTML = `TONARIS VIDEO DEBUG<br>MODE: ${mobile?'MOBILE':'DESKTOP'}<br>VIDEO: ${vw} × ${vh}<br>DISPLAY: ${Math.round(r.width)} × ${Math.round(r.height)}<br>DPR: ${window.devicePixelRatio.toFixed(2)}<br>SCALE: ${scale.toFixed(2)}×<br>SOURCE: ${shortSrc}`;
    };
    hero.querySelectorAll('video').forEach(v => v.addEventListener('loadedmetadata', update));
    window.addEventListener('resize', update, {passive:true});
    update();
  });
})();
